import { Modal } from "react-bootstrap";
import {
  EventItem,
  formatDate,
  getDurationDays,
  TYPE_COLORS,
  TypeBadge,
} from ".";

const ViewEventModal: React.FC<{
  event: EventItem | null;
  onClose: () => void;
  onEdit?: (e: EventItem) => void;
  onDelete?: (e: EventItem) => void;
}> = ({ event, onClose, onEdit, onDelete }) => {
  if (!event) return null;
  const c = TYPE_COLORS[event.type];

  return (
    <Modal show={event !== null} onHide={onClose} centered>
      <Modal.Header>
        <Modal.Title>Détail de l'événement</Modal.Title>
        <button
          type="button"
          className="btn btn-sm btn-danger"
          onClick={onClose}
        >
          x
        </button>
      </Modal.Header>
      <Modal.Body>
        {/* Color accent strip */}
        <div
          style={{
            height: 4,
            borderRadius: 6,
            background: c.bg,
            marginBottom: "1.25rem",
            marginLeft: "-1.5rem",
            marginRight: "-1.5rem",
            width: "calc(100% + 3rem)",
          }}
        />

        {/* Type + Title */}
        <div className="mb-3">
          <TypeBadge type={event.type} />
          <h5
            style={{
              marginTop: "0.625rem",
              marginBottom: 0,
              fontWeight: 800,
              color: "#1e293b",
            }}
          >
            {event.title}
          </h5>
        </div>

        {/* Dates */}
        <div className="row g-2 mb-3">
          <div className="col-6">
            <div
              className="text-center p-3"
              style={{ background: "#f8fafc", borderRadius: "8px" }}
            >
              <div
                style={{
                  fontSize: "0.75rem",
                  color: "#64748b",
                  marginBottom: "0.25rem",
                }}
              >
                <i className="fa fa-calendar me-1" />
                Début
              </div>
              <div style={{ fontWeight: 600, color: "#1e293b" }}>
                {formatDate(event.start_date)}
              </div>
            </div>
          </div>
          <div className="col-6">
            <div
              className="text-center p-3"
              style={{ background: "#f8fafc", borderRadius: "8px" }}
            >
              <div
                style={{
                  fontSize: "0.75rem",
                  color: "#64748b",
                  marginBottom: "0.25rem",
                }}
              >
                <i className="fa fa-calendar me-1" />
                Fin
              </div>
              <div style={{ fontWeight: 600, color: "#1e293b" }}>
                {formatDate(event.end_date)}
              </div>
            </div>
          </div>
        </div>

        {/* Duration */}
        <div
          style={{
            fontSize: "0.85rem",
            color: "#64748b",
            marginBottom: "1rem",
            display: "flex",
            alignItems: "center",
            gap: "0.4rem",
          }}
        >
          <i className="fa fa-clock" />
          Durée :{" "}
          <strong style={{ color: "#1e293b" }}>
            {getDurationDays(event.start_date, event.end_date)} jour(s)
          </strong>
        </div>

        {/* Description */}
        {event.description && (
          <div className="mb-3">
            <div
              style={{
                fontSize: "0.85rem",
                fontWeight: 600,
                color: "#475569",
                marginBottom: "0.5rem",
              }}
            >
              <i className="fa fa-comment me-2" />
              Description
            </div>
            <p style={{ margin: 0, fontSize: "0.875rem", color: "#1e293b" }}>
              {event.description}
            </p>
          </div>
        )}

        {/* Audience */}
        <div className="mb-3">
          <div
            style={{
              fontSize: "0.75rem",
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: "0.06em",
              color: "#94a3b8",
              marginBottom: "0.5rem",
            }}
          >
            <i className="fa fa-person me-2" />
            Audience
          </div>
          {event.all_school ? (
            <span
              className="badge text-dark"
              style={{ background: "#e0e7ff", color: "#4338ca" }}
            >
              <i className="fa fa-building me-1" />
              Tout l'établissement
            </span>
          ) : (
            <div style={{ display: "flex", flexWrap: "wrap", gap: "0.35rem" }}>
              {Array.isArray(event.Classes) && event.Classes.length > 0 ? (
                event.Classes.map((cls: any) => (
                  <span
                    key={cls.id}
                    className="badge text-dark"
                    style={{ background: c.soft, color: c.bg }}
                  >
                    {cls.name}
                  </span>
                ))
              ) : (
                <span style={{ color: "#94a3b8", fontSize: "0.84rem" }}>—</span>
              )}
            </div>
          )}
        </div>

        {/* Created by */}
        {event.UserProfil && (
          <>
            <hr style={{ margin: "1rem 0" }} />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
                fontSize: "0.85rem",
                color: "#64748b",
              }}
            >
              <div
                style={{
                  width: 30,
                  height: 30,
                  borderRadius: "50%",
                  background: "#e0e7ff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#4f46e5",
                  flexShrink: 0,
                }}
              >
                <i className="fa fa-person" />
              </div>
              <span>
                Créé par{" "}
                <strong style={{ color: "#1e293b" }}>
                  {event.UserProfil.firstname} {event.UserProfil.lastname}
                </strong>
              </span>
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        {onEdit && (
          <button
            type="button"
            className="btn btn-primary me-auto"
            onClick={() => onEdit(event)}
          >
            <i className="fa fa-edit me-2" />
            Modifier
          </button>
        )}
        {onDelete && (
          <button
            type="button"
            className="btn btn-danger me-2"
            onClick={() => onDelete(event)}
          >
            <i className="fa fa-trash me-2" />
            Supprimer
          </button>
        )}
        <button type="button" className="btn btn-light" onClick={onClose}>
          Fermer
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewEventModal;
